// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"e2d7a2b8","784":"bc25c8f7"}[chunkId] + ".chunk.js";
};